import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/(private)/bando/$residenceId/attivita')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-call:activity.page_title'
				)
			}
		]
	}),
	staticData: {
		breadcrumb: 'admin-call:activity.page_title'
	},
	component: () => <Outlet />
})
